<template>
  <div>
    <shop-header :store-id="storeid" />
    <div :class="isRolldStore() ? 'rolld-background' : 'bg-white'">
      <div class="row m-4 justify-content-center">
        <div class="col-lg-9 py-4" style="min-height: 300px">
          <div v-if="trackingOrder" class="p-4">
            <div class="row">
              <div class="col-sm-12 text-center">
                <h2 v-if="!displayModel.isPayLater && showNewUi"  class="fw-normal badge badge-secondary bg-dark mt-4 p-3" style="border-radius: 50px">
                  {{ displayModel.orderState }}
                </h2>
                <h1 v-else-if="!displayModel.isPayLater && !showNewUi" class="fw-normal">
                  {{ displayModel.orderState }}
                </h1>
                <div
                  class="alert alert-primary"
                  role="alert"
                  v-if="createUserForGuest"
                >
                  <span>{{ $t("message.emailConfirmation") }}.</span>
                </div>
              </div>
            </div>
            <div class="row">
              <tracking-component
                @update-status="(u) => updateStatus(u)"
                :isCompletedOrder="false"
                :order="trackingOrder"
                :store="store"
              ></tracking-component>
            </div>
            <div
              class="row justify-content-center"
              v-if="
                displayModel.status >= 0 &&
                displayModel.status <= 4 &&
                !displayModel.isPayLater &&
                isDelivery()
              "
            >
              <h4>
                {{ estimatedPickupDeliveryTimeLabel }} :
                {{ estimeatedTimeText }}
              </h4>
            </div>
            <div class="row order-history-div">
              <div class="col-sm-12 text-center">
                <button
                  v-show="displayModel.status < 0"
                  type="button"
                  class="btn btn-primery btn-with-margins"
                  @click="backToCheckout"
                  :style="desktopStyles.btn"
                  :disabled="!checkLocalCartItemsExists"
                >
                  {{
                    displayModel.status === -2
                      ? $t("message.ReEnterPayment")
                      : $t("message.retry")
                  }}
                </button>
                <button
                  v-show="user"
                  type="button"
                  class="btn btn-primery btn-with-margins"
                  @click="viewHistory"
                  :style="desktopStyles.btn"
                >
                  {{ $t("message.viewMyOrderHistory") }}
                </button>
                <button
                  type="button"
                  class="btn btn-primery btn-with-margins"
                  @click="continueShopping"
                  :style="desktopStyles.btn"
                >
                  {{ $t("message.continueOrdering") }}
                </button>
                <button
                  type="button"
                  class="btn btn-primery btn-with-margins"
                  @click="viewOrder"
                  :style="desktopStyles.btn"
                  v-if="storeTable && payTableEnabled"
                >
                  {{ $t("message.viewOrder") }}
                </button>
              </div>
            </div>

            <div class="col-sm-12 text-center">
              <span
                v-if="displayModel.status < 0 && !checkLocalCartItemsExists"
                class="text-danger"
                >{{ $t("message.SessionLostRetryIsUnavailable") }}</span
              >
              <poweredby />
            </div>
          </div>
          <progressindicator v-else style="opacity: 0.4"></progressindicator>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import shared from "../../../sharedscripts/shop/Checkout/CompleteOrder.js";
import TrackingComponent from "../../user/partials/trackingComponent";
import ShopHeader from "../partials/shopheader";
import poweredby from "../../shared/poweredby";
import Progressindicator from "../../progressindicator";
export default {
  components: { ShopHeader, poweredby, TrackingComponent, Progressindicator },
  props: {
    storeid: {
      type: String,
      default: "",
    },
    orderid: {
      type: String,
      default: "",
    },
    userid: {
      type: String,
      default: "",
    },
    createUserForGuest: {
      type: Boolean,
      default: false,
    },
    selectedCompanyId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      store: {},
      trackingOrder: null,
      displayModel: {
        orderState: "Order Sent!",
        orderMode: "Pickup",
        status: -1,
        isPayLater: false,
      },
    };
  },
  beforeDestroy() {
    this.beforeDestroyComponent();
  },
  computed: {
    ...mapGetters(["user", "desktopStyles"]),
    ...shared.computed
  },
  watch: {
    ...shared.watch,
  },
  created() {
    this.createdComponent();
  },
  methods: {
    ...shared.methods,
  },
};
</script>
